import client from "../client/client";

class AiFeatureService {
	getFeatures({ name, direction = "DESC" }, cancelToken) {
		return client.get("/backoffice/ai-features/list", {
			params: { name, direction },
			config: { cancelToken },
		});
	}

	updateFeatureAgent({ featureId, agentId }, { add }, cancelToken) {
		return client.patch(`/backoffice/ai-features/${featureId}/agents/${agentId}`, {
			params: { add },
			config: { cancelToken },
		});
	}
}

export default new AiFeatureService();
